// src/components/dashboard/cases/newCase/case_id/caseTable/utils/dock.js
export const LAYOUT_KEY = "stlViewerLayout";

export const loadLayout = () => {
  try {
    const raw = window.localStorage.getItem(LAYOUT_KEY);
    return raw ? JSON.parse(raw) || {} : {};
  } catch {
    return {};
  }
};

export const saveLayout = (patch) => {
  try {
    window.localStorage.setItem(
      LAYOUT_KEY,
      JSON.stringify({ ...loadLayout(), ...patch })
    );
  } catch {
    /* ignore */
  }
};

export const clamp01 = (v) => Math.min(1, Math.max(0, v));

export const DOCK_EDGES = ["left", "right", "top", "bottom"];
export const DOCK_POS = ["start", "center", "end"];

export const snapDock = (host, clientX, clientY) => {
  const c = host.getBoundingClientRect();
  const fx = clamp01((clientX - c.left) / Math.max(c.width, 1));
  const fy = clamp01((clientY - c.top) / Math.max(c.height, 1));
  const d = { left: fx, right: 1 - fx, top: fy, bottom: 1 - fy };
  const edge = DOCK_EDGES.reduce((a, b) => (d[a] <= d[b] ? a : b));
  const along = edge === "left" || edge === "right" ? fy : fx;
  const pos = along < 0.28 ? "start" : along > 0.72 ? "end" : "center";
  return { edge, pos };
};

export const swallowNextContextMenu = () => {
  const block = (e) => e.preventDefault();
  window.addEventListener("contextmenu", block, true);
  setTimeout(() => window.removeEventListener("contextmenu", block, true), 400);
};